import { nullableSchema, objectSchema } from "vue-utils"
import type { INamed, IncidentEntity, Nullable } from "../IncidentEntity"

export interface SearchAndRescueUnit extends IncidentEntity, INamed {
	/**
	 * According to James Way @harbours, they keep this list themselves and can differ based on craft.
	 * The user will have to manually the crew numbers
	 */
	totalCrew: Nullable<number>

	/**
	 * Allows customising asset tasks information
	 */
	isCustom: boolean
}

export const SearchAndRescueUnit = objectSchema<SearchAndRescueUnit>({
	id: Number,
	name: String,
	totalCrew: nullableSchema(Number),
	isCustom: Boolean,
})
